import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import Box from '@mui/material/Box';
import { Link } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import {
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBCardImage,
  MDBContainer,
  MDBIcon,
  MDBBtn,
} from "mdb-react-ui-kit";


import { getTour } from "../redux/features/tourSlice";
import { getContentById } from "../redux/features/contentSlice";
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  palette: {
      primary: {
          main: '#1E2D3D',
      },
      secondary: {
          main: '#00d3f7',
      }
  }
});

const columns = [
  {
    field: 'title',
    headerName: 'Título do índice',
    width: 900,
    editable: true,
  },
];

const SingleTour = () => {
  const dispatch = useDispatch();
  const { tour, contents, tips  } = useSelector((state) => ({ ...state.tour, ...state.content, ...state.tips }));
  const { id } = useParams();
  const navigate = useNavigate();

  const [selectionModel, setSelectionModel] = useState([]);

  const tags = tour?.tags;

  const getSingleTour = () => {
    if (!id) return;
    dispatch(getTour(id));
    dispatch(getContentById(id));
  }

  // const getRelatedToursFromApi = useCallback(() => { 
  //   if(!tags) return;
  //   dispatch(getRelatedTours(tags));
  // }, [tags])

  useEffect(() => {
    getSingleTour();
    // getRelatedToursFromApi();
  }, []);

  return (
    <>
      <MDBContainer>
        <MDBCard className="mb-3 mt-2">
          <MDBCardImage
            position="top"
            style={{ width: "100%", maxHeight: "600px" }}
            src={tour.imageFile}
            alt={tour.title}
          />
          <MDBCardBody>
            <MDBBtn
              tag="a"
              color="none"
              style={{ float: "left", color: "#000" }}
              onClick={() => navigate("/")}
            >
              <MDBIcon
                fas
                size="lg"
                icon="long-arrow-alt-left"
                style={{ float: "left" }}
              />
            </MDBBtn>
            <h5>{tour.title}</h5>
            <div style={{ float: "left" }}>
              <span className="text-start">
                {tour && tour.tags && tour.tags.map((item, i) => <p key={`tag-${i}`}>{`#${item} `}</p>)}
              </span>
            </div>
            <br />
            <MDBCardText className="text-start mt-2">
              <small className="text-muted">
                {`Criado há: ${moment(tour?.createdAt).fromNow()}`}
              </small>
            </MDBCardText>
            <div style={{ float: "left", marginTop: "10px", marginLeft: "10px" }}>
                <Link to={`/addContent/${id}`}>
                        <MDBBtn
                          size="sm"
                          color="primary"
                          onClick={() => navigate(``)}
                        >
                          Adicionar Índice
                        </MDBBtn>
                </Link>
              </div>
            <div style={{ float: "left", marginTop: "10px", marginLeft: "10px" }}>
              <Link to={`/addTips/${selectionModel[0]}`}>
                      <MDBBtn
                        size="sm"
                        color="success"
                        onClick={() => navigate(``)}
                      >
                        Adicionar Dicas
                      </MDBBtn>
              </Link>
            </div>
            <div style={{ float: "left", marginTop: "10px", marginLeft: "10px" }}>
              <Link to={`/tips/${selectionModel[0]}`}>
                      <MDBBtn
                        size="sm"
                        color="white"
                        onClick={() => navigate(``)}
                      >
                        Visualizar Dicas
                      </MDBBtn>
              </Link>
            </div>
            <p>* Selecione o índice que deseja visualizar as dicas</p>

          </MDBCardBody>
          <div style={{ float: "left", marginLeft: "23px", marginRight: "23px", marginBottom: "20px" }}>
            <Box sx={{ height: 400, width: '100%' }}>
                  <DataGrid
                    rows={contents}
                    columns={columns}
                    pageSize={6}
                    rowsPerPageOptions={[6]}
                    checkboxSelection
                    disableSelectionOnClick
                    disableMultipleSelection={true}
                    getRowId={(row) => row._id}
                    onSelectionModelChange={(newSelectionModel) => {
                      setSelectionModel((prevModel) =>
                        newSelectionModel.filter((newId) => !prevModel.includes(newId))
                      );
                    }}
                    selectionModel={selectionModel}
                  />
            </Box>
            </div>
        </MDBCard>
      </MDBContainer>
    </>
  );
};

export default SingleTour;
